import { createTheme } from '@mui/material/styles';

// Centralized MUI theme. Prefer `theme.palette.*` and `theme.spacing()` over
// hardcoded values in new/refactored code. Existing hex literals can be
// migrated incrementally.
const theme = createTheme({
  palette: {
    primary: {
      main: '#E73A6E', // Bictorys brand magenta
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#16243D', // Deep navy (sidebar / buttons)
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#20A144',
    },
    warning: {
      main: '#EF7D00',
    },
    error: {
      main: '#FF0000',
    },
    grey: {
      50: '#F8F8F8',
      100: '#F0F0F0',
      200: '#D9D9D9',
      400: '#979797',
      600: '#666666',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: "'Nunito', system-ui, Avenir, Helvetica, Arial, sans-serif",
  },
  shape: {
    borderRadius: 10,
  },
});

export default theme;
